import { type IEquity } from '~/api/interface'

export const memberKeys: () => Map<keyof IEquity, string> = () => {
  const { $t } = useNuxtApp()
  return new Map([
    ['subject', $t('zhu-ti-shuo-ming')],
    ['work_permanent', $t('zuo-pin-yong-jiu-shou-quan')],
    ['licensor_text', $t('shou-quan-zhu-ti')],
    ['account_count', $t('xi-wei')],
    ['render_pass', $t('fu-wu-qi-zhuan-xian')],
    ['rights_by_time', $t('yan-bi')],
    ['speed', $t('pai-dui-jia-su')],
    ['work_sublicense', $t('zuo-pin-zhuan-shou-quan-zhu-ti')],
    ['range', $t('shou-quan-fan-wei')],
    ['spread', $t('xin-mei-ti-ping-tai-ji-xian-shang-tui-guang')],
    ['net_use', $t('wang-zhan-ying-yong-cheng-xu-wang-luo-shi-pin-yong-tu')],
    ['outdoor_advertising', $t('hu-wai-guang-gao')],
    ['roles', $t('san-wei-xing-xiang-ku')],
    ['scene', $t('san-wei-chang-jing-ku-yan-bo-shi')],
    ['tone', $t('yin-se-ku')],
    [
      'look_customize',
      $t(
        'xing-xiang-sheng-yin-chang-jing-fu-zhuang-dong-zuo-deng-ge-lei-zi-chan-ge-xing-hua-ding-zhi'
      ),
    ], // 所有 _customize 结尾的，取一个判断即可
    ['file_upload_type', $t('zhi-chi-duo-zhong-ge-shi-de-su-cai-shang-chuan')],
    ['font_limit', $t('dan-ge-wen-jian-shang-chuan-da-xiao')], // 所有 _limit 结尾的
    ['storage', $t('yun-duan-cun-chu-kong-jian')],
    ['max_resolution', $t('zui-gao-zhi-chi-shi-pin-qing-xi-du')],
    ['video_download_type', $t('shi-pin-wen-jian-xia-zai')],
    ['watermark', $t('shui-yin')],
    ['recycle', $t('hui-shou-zhan')],
    ['single_video_max_duration', $t('dan-tiao-shi-pin-sheng-cheng-shi-chang')],
    ['publish', $t('yi-jian-fa-bu')],
    ['team_work', $t('tuan-dui-duo-ren-xie-zuo')],
    ['team_space', $t('tuan-dui-kong-jian')],
    ['brand_guidelines', $t('pin-pai-gui-fan')],
    ['member_management', $t('tuan-dui-guan-li')],
    ['privacy_protection', $t('shu-ju-jia-mi-bao-hu-yin-si')],
    ['exclusive_service', $t('1v1-zhuan-ren-fu-wu')],
    ['exclusive_team', $t('shou-hou-ke-fu')],
  ])
}
export function fileSizeLimit(kb: number) {
  const gb = kb / Math.pow(1024, 3)
  if (gb < 1) {
    return kb / Math.pow(1024, 2) + 'MB'
  }
  return Math.ceil(kb / Math.pow(1024, 3)) + 'GB'
}
